import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-87d47ef6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-popup" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "login-popup-google mb-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fab fa-google" }, null, -1))
const _hoisted_6 = { class: "login-popup-facebook" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fab fa-facebook-square" }, null, -1))
const _hoisted_8 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Alert = _resolveComponent("Alert")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push('/')))
  }, {
    header: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t("landing-page.view.login")), 1)
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("form", {
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.submit(_ctx.email, _ctx.password)), ["prevent"]))
        }, [
          _createVNode(_component_Input, {
            modelValue: _ctx.v$.email.$model,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.email.$model) = $event)),
            type: "email",
            label: _ctx.$t('landing-page.view.email'),
            invalid: _ctx.v$.email.email.$invalid && _ctx.v$.email.$dirty,
            errorMessage: _ctx.$t('errors.email-is-invalid'),
            onKeyboard: _ctx.toggleModalKeyboardClass
          }, null, 8, ["modelValue", "label", "invalid", "errorMessage", "onKeyboard"]),
          _createVNode(_component_Input, {
            modelValue: _ctx.v$.password.$model,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.password.$model) = $event)),
            type: "password",
            label: _ctx.$t('landing-page.view.password'),
            onKeyboard: _ctx.toggleModalKeyboardClass
          }, null, 8, ["modelValue", "label", "onKeyboard"]),
          _createElementVNode("button", {
            disabled: _ctx.v$.$invalid,
            type: "submit",
            class: "form"
          }, [
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t("landing-page.view.login")), 1))
              : (_openBlock(), _createBlock(_component_Spinner, {
                  key: 1,
                  size: "sm",
                  style: {"margin":"auto"}
                }))
          ], 8, _hoisted_2),
          _createVNode(_component_Alert, { message: _ctx.backendError }, null, 8, ["message"]),
          _createElementVNode("div", null, [
            _createVNode(_component_router_link, { to: { name: 'LandingPage', query: { view: 'forgot-password' } } }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("landing-page.view.forgot-password")), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.socialMediaLogin('google'))),
              type: "button",
              class: "form-outline"
            }, [
              _hoisted_5,
              _createTextVNode("  " + _toDisplayString(_ctx.$t("landing-page.view.login-with-google")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.socialMediaLogin('facebook'))),
              type: "button",
              class: "form-outline"
            }, [
              _hoisted_7,
              _createTextVNode("  " + _toDisplayString(_ctx.$t("landing-page.view.login-with-facebook")), 1)
            ])
          ])
        ], 32),
        _createElementVNode("div", {
          role: "navigation",
          "aria-label": _ctx.$t('landing-page.view.register'),
          class: "login-popup-footer"
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("landing-page.view.new-user")) + " ", 1),
          _createVNode(_component_router_link, { to: { name: 'LandingPage', query: { view: 'register' } } }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("landing-page.view.register")), 1)
            ]),
            _: 1
          })
        ], 8, _hoisted_8)
      ])
    ]),
    _: 1
  }))
}